import { Flex, SkeletonBox, Spacing } from '@billy/design-system'
import type { ReactElement } from 'react'

// Heights of the five groups in PaymentsAndRemindersSettingsFormFields, each at full width.
// Bank transfer: 20px label + 8px gap + 198px card with IBAN and SWIFT/BIC + Bank rows.
// PayPal, Offline payment and start date: 20px label + 4px gap + 50px input.
// Reminders: 44px heading and description + 16px gap + 204px card with three rows and two dividers - 8px gap difference.
const paymentsAndRemindersSettingsFormFieldsSkeletons = [
  { height: 226, id: 'bank-transfer' },
  { height: 74, id: 'paypal' },
  { height: 74, id: 'offline-payment' },
  { height: 256, id: 'automatic-payment-reminders' },
  { height: 74, id: 'reminders-start-date' },
]

export const PaymentsAndRemindersSettingsFormFieldsSkeletons = (): ReactElement => (
  <Flex flexDirection="column" gap={Spacing.S24}>
    {paymentsAndRemindersSettingsFormFieldsSkeletons.map(({ height, id }) => (
      <SkeletonBox fullWidth height={height} key={id} />
    ))}
  </Flex>
)
